enum PesoDoPacienteEnum {
  MaiorQue180Quilos = 'MaiorQue180Quilos',
  MenorQue2Quilos = 'MenorQue2Quilos',
  NaoSeAplica = 'NaoSeAplica',
}

export default PesoDoPacienteEnum
